import React, { useEffect, useState } from 'react';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

//Componentes
import CadastroRegional from './components/cadastroRegional';
import TabelaListagem from '../../../../components/TabelaListagem/TabelaListagem';

//Constants
import { actionsTable } from '../../../../constants/MaterialTable';

//API
import regional_api from '../../../../api/regional_api';

//Helpers
import { showMessage } from "../../../../helpers/message";

//Context
import { useAuth } from '../../../../context/auth';

function Regional() {
  //State para pegar as regionais cadastradas
  const [listRegional, setListRegional] = useState([]);

  //State para editar
  const [regional_id, setRegional_id] = useState(null);

  //State para editar
  const [regionalNova, setRegionalNova] = useState(false);

  const { setLoading } = useAuth()

  const loadRegionis = () => {
    setLoading(true);
    regional_api.getList("Ativo").then(response => {
      setListRegional(response.data);
    })
    .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
    .finally(() => setLoading(false));
  }

  const editar = (regionalEditar) => {
    setRegional_id(regionalEditar.id);
  }

  //Variavel que guarda as ações da tabela
  const actions = [actionsTable.editar(editar)];

  useEffect(() => {
    loadRegionis();
  }, []);

  //Cabeçalhos que a tabela terá
  const headers = [
    { value: "Descrição", objectValue: "identificacao", align: "left" },
    { value: "Status", objectValue: "status", align: "left" }
  ]
  
  const handleVoltar = () => {
    setRegional_id(null);
    setRegionalNova(false);
    loadRegionis();
  }

  if (regionalNova || regional_id) {
    return <CadastroRegional
      id={regional_id}
      handleVoltar={handleVoltar}
    />
  }

  return (
    <>
      <div className='d-flex align-items-center justify-content-between mb-4'>
        <h4 className='text-secondary m-0'>Regionais</h4>
        <Button
          color='success'
          onClick={() => setRegionalNova(true)}
        >
          <FontAwesomeIcon icon={faPlus} />  Adicionar
        </Button>
      </div >
      <TabelaListagem
        actions={actions}
        title={"Lista de regionais"}
        headers={headers}
        items={listRegional}
      />
    </>
  );
}

export default Regional;